import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Row, Col, Text } from 'rsuite';
import { selectConfigExpressSettingsName } from '../../../../store/slices/config/configSelectors';
import {
  selectSelectedPaymentMethod,
  selectPaymentCheckFailed,
  selectPaymentSuccessInfo,
} from '../../../../store/slices/payment/paymentSelectors';
import { PAYMENT_METHODS } from '../../constants';
import PaymentCompletedCheck from './PaymentCompletedCheck';

const TaxSuccessFields = () => {
  const jurisdictionName = useSelector(selectConfigExpressSettingsName);
  const paymentSuccessInfo = useSelector(selectPaymentSuccessInfo);
  const paymentCheckFailed = useSelector(selectPaymentCheckFailed);
  const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);

  const message = useMemo(
    () =>
      `Thank you for submitting your tax payment. 
        We have emailed you a receipt of your payment. 
        Your actions today allow short term rentals to be an attractive choice for ${jurisdictionName} visitors, 
        while maintaining the residential character of our neighborhoods.`,
    [jurisdictionName]
  );

  if (paymentCheckFailed) {
    return null;
  }

  return (
    <Grid
      className="content-section"
      data-testid="tax-success-fields"
    >
      <Row>
        <Col xs={24}>
          <Grid
            fluid
            className="mb-24"
          >
            {paymentSuccessInfo && (
              <>
                {paymentSuccessInfo.paymentConfirmation && (
                  <>
                    <Row>
                      <Col xs={24}>
                        <Text>Confirmation Number:</Text>
                      </Col>
                    </Row>
                    <Row className="mb-24">
                      <Col xs={24}>
                        <Text
                          className="text-bold header-text-h4"
                          data-testid="confirmation-number"
                        >
                          {paymentSuccessInfo?.paymentConfirmation}
                        </Text>
                      </Col>
                    </Row>
                  </>
                )}
                {selectedPaymentMethod === PAYMENT_METHODS.CHECK && (
                  <PaymentCompletedCheck />
                )}
              </>
            )}
            <Row>
              <Col xs={24}>
                <Text className="text-small">{message}</Text>
              </Col>
            </Row>
          </Grid>
        </Col>
      </Row>
    </Grid>
  );
};

export default TaxSuccessFields;
